<script setup>
import { provide, useTemplateRef } from 'vue';

const layoutRef = useTemplateRef('overlay');
provide('layout', layoutRef);
</script>

<template>
    <div
        ref="overlay"
        class="fixed inset-0 flex h-full overflow-y-auto bg-white"
    >
        <div class="m-8 flex flex-1">
            <slot />
        </div>
    </div>
</template>
